import MicroModal from 'micromodal';
const modal = () => {
    MicroModal.init();
};
export default modal;